/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState, useCallback } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../../utils/customHooks";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";
import getCroppedImg from "../../utils/cropImage";
import { CropperWrapper } from "../../utils/CropperWrapper";
import ImageUploader from "../../utils/ImageUploader";

// CD42 — KD46500/600 WHITE BABY 330x333
// Pozycje tekstów (style inline, w mm):
//   top   = górna krawędź pola tekstowego
//   left  = środek tekstu (textAlign center + translateX(-50%)) albo lewa krawędź (textAlign left)
//   right = prawa krawędź pola (textAlign right)
// maxWidthN = maks. szerokość tekstu w px — dłuższy tekst zmniejsza czcionkę.
// Uwaga: lineHeight w stylu InlineEdit nie działa (nadpisuje go `font: inherit`), zawsze wynosi 1.5.
export const Cd42: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("00:26");
  const [text2, setText2] = useState<string>("ALA");
  const [text3, setText3] = useState<string>("00:29");
  const [text4, setText4] = useState<string>("OSKAR");
  const [text5, setText5] = useState<string>("czwartek");
  const [text6, setText6] = useState<string>("55");
  const [text7, setText7] = useState<string>("cm");
  const [text8, setText8] = useState<string>("3200");
  const [text9, setText9] = useState<string>("g");
  const [text10, setText10] = useState<string>("7");
  const [text11, setText11] = useState<string>("stycznia 2021");
  const [text12, setText12] = useState<string>("Nowa Sól");
  const [text13, setText13] = useState<string>("3600");
  const [text14, setText14] = useState<string>("g");
  const [text15, setText15] = useState<string>("50");
  const [text16, setText16] = useState<string>("cm");
  const text1BasicSize = 45;
  const text2BasicSize = 115;
  const text3BasicSize = 39;
  const text4BasicSize = 110;
  const text5BasicSize = 26;
  const text6BasicSize = 53;
  const text7BasicSize = 31;
  const text8BasicSize = 49;
  const text9BasicSize = 37;
  const text10BasicSize = 123;
  const text11BasicSize = 23;
  const text12BasicSize = 23;
  const text13BasicSize = 49;
  const text14BasicSize = 37;
  const text15BasicSize = 53;
  const text16BasicSize = 31;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const [fontSizeText4, setFontSizeText4] = useState<number>(text4BasicSize);
  const [fontSizeText5, setFontSizeText5] = useState<number>(text5BasicSize);
  const [fontSizeText6, setFontSizeText6] = useState<number>(text6BasicSize);
  const [fontSizeText7, setFontSizeText7] = useState<number>(text7BasicSize);
  const [fontSizeText8, setFontSizeText8] = useState<number>(text8BasicSize);
  const [fontSizeText9, setFontSizeText9] = useState<number>(text9BasicSize);
  const [fontSizeText10, setFontSizeText10] = useState<number>(text10BasicSize);
  const [fontSizeText11, setFontSizeText11] = useState<number>(text11BasicSize);
  const [fontSizeText12, setFontSizeText12] = useState<number>(text12BasicSize);
  const [fontSizeText13, setFontSizeText13] = useState<number>(text13BasicSize);
  const [fontSizeText14, setFontSizeText14] = useState<number>(text14BasicSize);
  const [fontSizeText15, setFontSizeText15] = useState<number>(text15BasicSize);
  const [fontSizeText16, setFontSizeText16] = useState<number>(text16BasicSize);
  const { saveTemplate, isSaving } = useSaveTemplate();
  const [image1, setImage1] = useState<string | null>(null);
  const [croppedImage1, setCroppedImage1] = useState<string | null>(null);
  const [crop1, setCrop1] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [zoom1, setZoom1] = useState<number>(1);
  const [croppedAreaPixels1, setCroppedAreaPixels1] = useState<any>(null);
  const [step1, setStep1] = useState<"select" | "crop" | "view">("select");
  const [image2, setImage2] = useState<string | null>(null);
  const [croppedImage2, setCroppedImage2] = useState<string | null>(null);
  const [crop2, setCrop2] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [zoom2, setZoom2] = useState<number>(1);
  const [croppedAreaPixels2, setCroppedAreaPixels2] = useState<any>(null);
  const [step2, setStep2] = useState<"select" | "crop" | "view">("select");

  const pdfWidth = "330mm"; // PDF width in mm
  const pdfHeight = "333mm"; // PDF height in mm
  const font1 = "JustSayin";
  const font2 = "MaritimeTropicalNeue";
  const maxWidth1 = 179;
  const maxWidth2 = 271;
  const maxWidth3 = 166;
  const maxWidth4 = 429;
  const maxWidth5 = 189;
  const maxWidth6 = 66;
  const maxWidth7 = 48;
  const maxWidth8 = 116;
  const maxWidth9 = 31;
  const maxWidth10 = 133;
  const maxWidth11 = 215;
  const maxWidth12 = 168;
  const maxWidth13 = 116;
  const maxWidth14 = 31;
  const maxWidth15 = 67;
  const maxWidth16 = 48;
  // Okno na zdjęcie użytkownika nr 1
  const photoTop1 = "34.8mm";
  const photoLeft1 = "68.8mm";
  const photoWidth1 = "105.8mm";
  const photoHeight1 = "101.8mm";
  const photoAspect1 = 105.8 / 101.8;
  // Okno na zdjęcie użytkownika nr 2
  const photoTop2 = "80.4mm";
  const photoLeft2 = "140mm";
  const photoWidth2 = "108.6mm";
  const photoHeight2 = "104.6mm";
  const photoAspect2 = 108.6 / 104.6;

  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number,
    fontFamily: string,
    maxWidth: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px ${fontFamily}`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  // Czekamy na załadowanie fontu, inaczej canvas mierzy tekst fontem zastępczym.
  const ensureFont = (fontFamily: string) => document.fonts.load(`1em ${fontFamily}`);

  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText1(adjustFontSize(text1, fontSizeText1, text1BasicSize, 14, font1, maxWidth1))
    );
  }, [text1]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText2(adjustFontSize(text2, fontSizeText2, text2BasicSize, 14, font2, maxWidth2))
    );
  }, [text2]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText3(adjustFontSize(text3, fontSizeText3, text3BasicSize, 10, font1, maxWidth3))
    );
  }, [text3]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText4(adjustFontSize(text4, fontSizeText4, text4BasicSize, 14, font2, maxWidth4))
    );
  }, [text4]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText5(adjustFontSize(text5, fontSizeText5, text5BasicSize, 10, font1, maxWidth5))
    );
  }, [text5]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText6(adjustFontSize(text6, fontSizeText6, text6BasicSize, 14, font1, maxWidth6))
    );
  }, [text6]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText7(adjustFontSize(text7, fontSizeText7, text7BasicSize, 10, font1, maxWidth7))
    );
  }, [text7]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText8(adjustFontSize(text8, fontSizeText8, text8BasicSize, 14, font1, maxWidth8))
    );
  }, [text8]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText9(adjustFontSize(text9, fontSizeText9, text9BasicSize, 10, font1, maxWidth9))
    );
  }, [text9]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText10(adjustFontSize(text10, fontSizeText10, text10BasicSize, 14, font1, maxWidth10))
    );
  }, [text10]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText11(adjustFontSize(text11, fontSizeText11, text11BasicSize, 10, font1, maxWidth11))
    );
  }, [text11]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText12(adjustFontSize(text12, fontSizeText12, text12BasicSize, 10, font1, maxWidth12))
    );
  }, [text12]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText13(adjustFontSize(text13, fontSizeText13, text13BasicSize, 14, font1, maxWidth13))
    );
  }, [text13]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText14(adjustFontSize(text14, fontSizeText14, text14BasicSize, 10, font1, maxWidth14))
    );
  }, [text14]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText15(adjustFontSize(text15, fontSizeText15, text15BasicSize, 14, font1, maxWidth15))
    );
  }, [text15]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText16(adjustFontSize(text16, fontSizeText16, text16BasicSize, 10, font1, maxWidth16))
    );
  }, [text16]);

  const handleSave = () => {
    // wszystkie zdjęcia są wymagane; do zapisu oryginału trafia pierwsze
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      croppedImage1 && croppedImage2 ? croppedImage1 : null,
      true
    );
  };

  const handleCropComplete1 = useCallback((croppedArea: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels1(croppedAreaPixels);
  }, []);

  const handleShowCroppedImage1 = useCallback(async () => {
    if (image1 && croppedAreaPixels1) {
      const croppedImg = await getCroppedImg(image1, croppedAreaPixels1);
      setCroppedImage1(croppedImg);
      setStep1("view");
    }
  }, [image1, croppedAreaPixels1]);

  const handleCropComplete2 = useCallback((croppedArea: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels2(croppedAreaPixels);
  }, []);

  const handleShowCroppedImage2 = useCallback(async () => {
    if (image2 && croppedAreaPixels2) {
      const croppedImg = await getCroppedImg(image2, croppedAreaPixels2);
      setCroppedImage2(croppedImg);
      setStep2("view");
    }
  }, [image2, croppedAreaPixels2]);

  return (
    <div style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#ffffff", padding: "80px",
      position: "relative",
    }}>
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />
      <div style={{ position: "absolute", top: "10px", left: "0px", right: "0px", margin: "auto", color: "white", width: "1060px", maxWidth: "100%", height: "70px", gap: "30px", display: "flex", alignItems: "center" }}>
        {step2 !== "crop" && (
          <ImageUploader
            inputId="file-upload-1"
            label="Zdjęcie 1 – lewe kółko"
            onImageChange={(image) => setImage1(image)}
            setStep={setStep1}
          />
        )}
        {step1 !== "crop" && (
          <ImageUploader
            inputId="file-upload-2"
            label="Zdjęcie 2 – prawe kółko"
            onImageChange={(image) => setImage2(image)}
            setStep={setStep2}
          />
        )}
        {(step1 === "crop" || step2 === "crop") && (
          <p>
            Aby wykadrować zdjęcie możesz kręcić kółkiem myszy i przesuwać obraz
          </p>
        )}
        <div style={{}}>
          {!(step1 === "crop" || step2 === "crop") && (
            <Button onClick={handleSave} disabled={isSaving}>
              {isSaving ? "Zapisywanie..." : "Zapisz"}
            </Button>
          )}
          {step1 === "crop" && (
            <Button onClick={handleShowCroppedImage1}>Zakończ kadrowanie</Button>
          )}
          {step2 === "crop" && (
            <Button onClick={handleShowCroppedImage2}>Zakończ kadrowanie</Button>
          )}
        </div>
      </div>

      <div
        id="printable-content"
        style={{
          position: "relative",
          width: pdfWidth,
          height: pdfHeight,
          fontFamily: "JustSayin, MaritimeTropicalNeue",
          backgroundColor: "#ffffff",
          margin: "auto",
        }}
      >
        {/* 00:26 */}
        <InlineEdit
          value={text1}
          setValue={setText1}
          style={{
            fontSize: `${fontSizeText1}px`,
            fontFamily: font1,
            color: "#53646b",
            position: "absolute",
            top: "139.4mm",
            left: "283.3mm",
            width: `${maxWidth1 + 10}px`,
            transform: "translateX(-50%) rotate(-12.5deg)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "-0.36px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* ALA */}
        <InlineEdit
          value={text2}
          setValue={setText2}
          style={{
            fontSize: `${fontSizeText2}px`,
            fontFamily: font2,
            color: "#2b2a29",
            position: "absolute",
            top: "145.2mm",
            left: "100.6mm",
            width: `${maxWidth2 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "6.02px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 00:29 */}
        <InlineEdit
          value={text3}
          setValue={setText3}
          style={{
            fontSize: `${fontSizeText3}px`,
            fontFamily: font1,
            color: "#53646b",
            position: "absolute",
            top: "195.9mm",
            left: "55.4mm",
            width: `${maxWidth3 + 10}px`,
            transform: "translateX(-50%) rotate(3.3deg)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "0.36px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* OSKAR */}
        <InlineEdit
          value={text4}
          setValue={setText4}
          style={{
            fontSize: `${fontSizeText4}px`,
            fontFamily: font2,
            color: "#2b2a29",
            position: "absolute",
            top: "178.6mm",
            left: "262.2mm",
            width: `${maxWidth4 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "5.75px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* czwartek */}
        <InlineEdit
          value={text5}
          setValue={setText5}
          style={{
            fontSize: `${fontSizeText5}px`,
            fontFamily: font1,
            color: "#fefaf7",
            position: "absolute",
            top: "207mm",
            left: "162.7mm",
            width: `${maxWidth5 + 10}px`,
            transform: "translateX(-50%) rotate(-5.2deg)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "-0.41px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 55 */}
        <InlineEdit
          value={text6}
          setValue={setText6}
          style={{
            fontSize: `${fontSizeText6}px`,
            fontFamily: font1,
            color: "#53646b",
            position: "absolute",
            top: "220.8mm",
            left: "255mm",
            width: `${maxWidth6 + 10}px`,
            transform: "translateX(-50%) rotate(-1.6deg)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* cm */}
        <InlineEdit
          value={text7}
          setValue={setText7}
          style={{
            fontSize: `${fontSizeText7}px`,
            fontFamily: font1,
            color: "#53646b",
            position: "absolute",
            top: "227.6mm",
            left: "269.5mm",
            width: `${maxWidth7 + 10}px`,
            transform: "translateX(-50%) rotate(-1.6deg)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "2.0px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 3200 */}
        <InlineEdit
          value={text8}
          setValue={setText8}
          style={{
            fontSize: `${fontSizeText8}px`,
            fontFamily: font1,
            color: "#53646b",
            position: "absolute",
            top: "226.2mm",
            left: "87.4mm",
            width: `${maxWidth8 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* g */}
        <InlineEdit
          value={text9}
          setValue={setText9}
          style={{
            fontSize: `${fontSizeText9}px`,
            fontFamily: font1,
            color: "#53646b",
            position: "absolute",
            top: "230.4mm",
            left: "107.6mm",
            width: `${maxWidth9 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 7 */}
        <InlineEdit
          value={text10}
          setValue={setText10}
          style={{
            fontSize: `${fontSizeText10}px`,
            fontFamily: font1,
            color: "#fefaf7",
            position: "absolute",
            top: "204.1mm",
            left: "163.9mm",
            width: `${maxWidth10 + 10}px`,
            transform: "translateX(-50%) rotate(-4.9deg)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* stycznia 2021 */}
        <InlineEdit
          value={text11}
          setValue={setText11}
          style={{
            fontSize: `${fontSizeText11}px`,
            fontFamily: font1,
            color: "#fefaf7",
            position: "absolute",
            top: "243.9mm",
            left: "166.9mm",
            width: `${maxWidth11 + 10}px`,
            transform: "translateX(-50%) rotate(-5.2deg)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "-0.15px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* Nowa Sól */}
        <InlineEdit
          value={text12}
          setValue={setText12}
          style={{
            fontSize: `${fontSizeText12}px`,
            fontFamily: font1,
            color: "#fefaf7",
            position: "absolute",
            top: "251.5mm",
            left: "167.4mm",
            width: `${maxWidth12 + 10}px`,
            transform: "translateX(-50%) rotate(-5.2deg)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 3600 */}
        <InlineEdit
          value={text13}
          setValue={setText13}
          style={{
            fontSize: `${fontSizeText13}px`,
            fontFamily: font1,
            color: "#53646b",
            position: "absolute",
            top: "258.5mm",
            left: "216.5mm",
            width: `${maxWidth13 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* g */}
        <InlineEdit
          value={text14}
          setValue={setText14}
          style={{
            fontSize: `${fontSizeText14}px`,
            fontFamily: font1,
            color: "#53646b",
            position: "absolute",
            top: "262.5mm",
            left: "236.6mm",
            width: `${maxWidth14 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 50 */}
        <InlineEdit
          value={text15}
          setValue={setText15}
          style={{
            fontSize: `${fontSizeText15}px`,
            fontFamily: font1,
            color: "#53646b",
            position: "absolute",
            top: "271.1mm",
            left: "114mm",
            width: `${maxWidth15 + 10}px`,
            transform: "translateX(-50%) rotate(-1.6deg)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* cm */}
        <InlineEdit
          value={text16}
          setValue={setText16}
          style={{
            fontSize: `${fontSizeText16}px`,
            fontFamily: font1,
            color: "#53646b",
            position: "absolute",
            top: "278.1mm",
            left: "128.5mm",
            width: `${maxWidth16 + 10}px`,
            transform: "translateX(-50%) rotate(-1.6deg)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "2.0px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />

        {/* Step: Crop (zdjęcie 1) */}
        {image1 && step1 === "crop" && (
          <CropperWrapper
            image={image1}
            crop={crop1}
            zoom={zoom1}
            aspect={photoAspect1}
            onCropChange={setCrop1}
            onZoomChange={setZoom1}
            onCropComplete={handleCropComplete1}
            style={{
              top: photoTop1,
              left: photoLeft1,
              width: photoWidth1,
              height: photoHeight1,
              transform: "none",
            }}
          />
        )}

        {/* Step: View (zdjęcie 1) */}
        {croppedImage1 && step1 === "view" && (
          <img
            src={croppedImage1}
            alt=""
            style={{
              position: "absolute",
              top: photoTop1,
              left: photoLeft1,
              width: photoWidth1,
              height: photoHeight1,
              objectFit: "cover",
              clipPath: "polygon(96.99% 50.56%, 96.88% 54.00%, 96.63% 57.44%, 96.20% 60.87%, 95.53% 64.27%, 94.62% 67.62%, 93.50% 70.90%, 92.14% 74.11%, 90.58% 77.22%, 88.81% 80.21%, 86.83% 83.08%, 84.66% 85.80%, 82.29% 88.38%, 79.76% 90.78%, 77.07% 92.99%, 74.23% 95.00%, 71.24% 96.82%, 67.99% 98.03%, 64.64% 98.87%, 61.27% 99.47%, 57.91% 99.91%, 54.54% 100.00%, 51.19% 99.85%, 47.89% 99.46%, 44.64% 99.03%, 41.44% 98.26%, 38.33% 97.27%, 35.34% 95.97%, 32.32% 94.83%, 29.44% 93.39%, 26.61% 91.83%, 23.90% 90.07%, 21.19% 88.27%, 18.67% 86.20%, 16.28% 83.94%, 13.98% 81.57%, 11.75% 79.09%, 9.45% 76.60%, 7.47% 73.81%, 5.49% 70.94%, 3.79% 67.87%, 2.47% 64.59%, 1.36% 61.20%, 0.58% 57.72%, 0.12% 54.16%, 0.00% 50.56%, 0.03% 46.97%, 0.39% 43.38%, 0.90% 39.82%, 1.64% 36.29%, 2.54% 32.79%, 3.59% 29.31%, 4.88% 25.89%, 6.41% 22.56%, 8.01% 19.21%, 10.07% 16.15%, 12.40% 13.30%, 15.19% 10.92%, 18.10% 8.76%, 21.15% 6.83%, 24.39% 5.31%, 27.65% 3.94%, 30.98% 2.84%, 34.32% 1.89%, 37.71% 1.29%, 41.09% 0.74%, 44.45% 0.25%, 47.84% 0.00%, 51.24% 0.00%, 54.63% 0.15%, 58.03% 0.55%, 61.45% 0.90%, 64.87% 1.51%, 68.30% 2.29%, 71.75% 3.23%, 75.20% 4.36%, 78.62% 5.77%, 81.84% 7.60%, 84.96% 9.68%, 88.02% 11.94%, 90.96% 14.44%, 93.59% 17.30%, 95.88% 20.47%, 97.45% 24.09%, 98.51% 27.91%, 99.28% 31.75%, 99.70% 35.61%, 99.84% 39.45%, 100.00% 43.20%, 99.90% 46.91%)",
              zIndex: 1,
            }}
          />
        )}

        {/* Step: Crop (zdjęcie 2) */}
        {image2 && step2 === "crop" && (
          <CropperWrapper
            image={image2}
            crop={crop2}
            zoom={zoom2}
            aspect={photoAspect2}
            onCropChange={setCrop2}
            onZoomChange={setZoom2}
            onCropComplete={handleCropComplete2}
            style={{
              top: photoTop2,
              left: photoLeft2,
              width: photoWidth2,
              height: photoHeight2,
              transform: "none",
            }}
          />
        )}

        {/* Step: View (zdjęcie 2) */}
        {croppedImage2 && step2 === "view" && (
          <img
            src={croppedImage2}
            alt=""
            style={{
              position: "absolute",
              top: photoTop2,
              left: photoLeft2,
              width: photoWidth2,
              height: photoHeight2,
              objectFit: "cover",
              clipPath: "polygon(99.93% 51.03%, 99.71% 54.67%, 99.35% 58.29%, 98.82% 61.90%, 98.15% 65.49%, 97.41% 69.11%, 96.67% 72.81%, 95.74% 76.53%, 94.46% 80.16%, 92.83% 83.68%, 90.12% 86.37%, 87.04% 88.62%, 83.99% 90.74%, 80.96% 92.77%, 77.72% 94.39%, 74.46% 95.82%, 71.19% 97.09%, 67.87% 98.10%, 64.51% 98.86%, 61.18% 99.46%, 57.83% 99.80%, 54.50% 100.00%, 51.19% 99.86%, 47.92% 99.47%, 44.70% 98.95%, 41.54% 98.20%, 38.45% 97.23%, 35.43% 96.13%, 32.47% 94.91%, 29.60% 93.48%, 26.80% 91.93%, 24.06% 90.27%, 21.48% 88.33%, 18.92% 86.34%, 16.49% 84.17%, 14.28% 81.76%, 12.00% 79.35%, 9.79% 76.81%, 7.59% 74.18%, 5.71% 71.29%, 4.02% 68.23%, 2.62% 65.00%, 1.45% 61.64%, 0.66% 58.16%, 0.12% 54.61%, 0.00% 51.03%, 0.03% 47.43%, 0.30% 43.84%, 0.72% 40.25%, 1.47% 36.71%, 2.39% 33.21%, 3.53% 29.75%, 4.74% 26.29%, 6.12% 22.86%, 7.83% 19.55%, 9.83% 16.43%, 12.12% 13.50%, 14.86% 11.02%, 17.79% 8.83%, 20.92% 6.96%, 24.13% 5.33%, 27.43% 3.94%, 30.82% 2.89%, 34.18% 1.92%, 37.59% 1.21%, 41.01% 0.75%, 44.41% 0.25%, 47.84% 0.00%, 51.26% 0.00%, 54.70% 0.15%, 58.13% 0.47%, 61.58% 0.93%, 65.03% 1.56%, 68.52% 2.27%, 71.99% 3.25%, 75.47% 4.41%, 78.90% 5.84%, 82.21% 7.63%, 85.23% 9.89%, 88.44% 12.04%, 91.32% 14.65%, 93.88% 17.59%, 96.10% 20.83%, 97.61% 24.50%, 98.68% 28.32%, 99.40% 32.19%, 99.74% 36.08%, 100.00% 39.90%, 99.98% 43.67%, 99.99% 47.37%)",
              zIndex: 6,
            }}
          />
        )}

        {/* Elementy tła leżące nad zdjęciem */}
        <img
          src="/images/CD42overlay.svg"
          alt=""
          style={{ width: "100%", height: "100%", position: 'absolute', top: '0', left: '0', zIndex: '8' }}
        />

        <img
          src="/images/CD42.svg"
          alt=""
          style={{ width: "100%", height: "100%", position: 'absolute', top: '0', left: '0', zIndex: '2' }}
        />
      </div>
    </div>
  );
};
